import { render } from "./SavTable.vue?vue&type=template&id=c7dc5a4e&scoped=true&ts=true&lang=pug"
import script from "./SavTable.vue?vue&type=script&lang=ts"
export * from "./SavTable.vue?vue&type=script&lang=ts"

import "./SavTable.vue?vue&type=style&index=0&id=c7dc5a4e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7dc5a4e"]])

export default __exports__